import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumericTextBoxComponent } from './numerictextbox.component';
/**
 * NgModule definition for the NumericTextBox component.
 */
export class NumericTextBoxModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        NumericTextBoxComponent
    ],
    exports: [
        NumericTextBoxComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NumericTextBoxModule_tsickle_Closure_declarations() {
/** @type {?} */
NumericTextBoxModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NumericTextBoxModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
